import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { elHacadGoals, islamicProducts } from '../../data/home';
import { ArrowButton } from '../ui/ArrowButton';
export function IslamicFinance() {
  return <section className="w-full bg-brand-deep py-24 text-white" data-id="element-97" data-mp="38bon8m49b6oj">
      <div className="mx-auto max-w-[1320px] px-6" data-id="element-98" data-mp="33ddeyftm148f">
        <div className="grid gap-14 lg:grid-cols-12" data-id="element-99" data-mp="33ahheslochki">
          <div className="lg:col-span-7" data-id="element-100" data-mp="4tdjk8r2cukr">
            <p className="text-[15px] font-medium text-gold" data-id="element-101" data-mp="4sc65xmkrvzv">Finance islamique</p>
            <h2 className="font-display mt-4 text-[56px] md:text-[88px]" data-id="element-102" data-mp="3w1sur4kkfqkt">
              Compte
              <br data-id="element-103" data-mp="3r03g7ey4wurz" />
              El-Haçad
            </h2>
            <p className="font-arabic mt-3 text-2xl text-white/50" lang="ar" dir="rtl" style={{
            textAlign: 'left'
          }} data-id="element-104" data-mp="3n12wzvbqvq4g">
              حساب الحصاد
            </p>
            <p className="mt-7 max-w-lg text-[17px] leading-relaxed text-white/70" data-id="element-105" data-mp="2fket8nkvrvr6">
              Une méthode d’épargne rentable et sûre, gérée conformément aux principes de la Charia, pour vous aider
              à atteindre vos objectifs et réaliser vos projets.
            </p>
            <div className="mt-9 flex flex-wrap gap-3" data-id="element-106" data-mp="1gfiomsruo4qt">
              <ArrowButton to="/particuliers/compte-el-hacad" variant="green" data-id="element-107" data-mp="12halu484u97q">
                Découvrir El-Haçad
              </ArrowButton>
              <Link to="/finance-islamique" className="inline-flex items-center rounded-full border border-white/20 px-6 py-3.5 text-[15px] font-medium text-white transition-colors hover:border-white/50" data-id="element-108" data-mp="16k7b2ds6h3kn">
                Nos principes
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-109" data-mp="nrd3w60sqfqz">
            <div className="rounded-[28px] bg-white/[0.06] p-8 md:p-10" data-id="element-110" data-mp="ns63mn1c84zm">
              <p className="text-[15px] font-medium text-white" data-id="element-111" data-mp="9rll7rzc4b6n">Quel que soit votre objectif d’épargne</p>
              <ul className="mt-6 space-y-4" data-id="element-112" data-mp="epwt3x62kbm8">
                {elHacadGoals.map(goal => <li key={goal} className="flex items-center gap-4 text-[17px] text-white/85" data-id="element-113" data-mp="2ggdwr0svz9jx">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold text-brand-deep" data-id="element-114" data-mp="2bp5gplx1wpxs">
                      <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-115" data-mp="26qu7ndekyjgm" />
                    </span>
                    {goal}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 grid gap-10 border-t border-white/10 pt-10 md:grid-cols-3" data-id="element-116" data-mp="2zcm1m3hzliep">
          {islamicProducts.map(p => <Link key={p.name} to={`/finance-islamique/${p.name.toLowerCase()}`} className="group" data-id="element-117" data-mp="2qdiiizitl307">
              <p className="font-display text-[36px] text-white transition-colors group-hover:text-gold" data-id="element-118" data-mp="2lg06v1df49oi">{p.name}</p>
              <p className="mt-2 text-[15px] text-white/60" data-id="element-119" data-mp="1ezwiukfc3j0f">{p.text}</p>
            </Link>)}
        </div>
      </div>
    </section>;
}